'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwPodElement = require('./CwPodElement.scss');

var _CwPodElement2 = _interopRequireDefault(_CwPodElement);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwPodElement = function CwPodElement(props) {
  var _cx;

  if (props.ghostPodElement) {
    return _react2.default.createElement('div', { className: _CwPodElement2.default.wrap });
  }

  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)(_CwPodElement2.default.wrap, (_cx = {}, (0, _defineProperty3.default)(_cx, _CwPodElement2.default.label, props.label), (0, _defineProperty3.default)(_cx, _CwPodElement2.default.required, props.label && props.isRequired), (0, _defineProperty3.default)(_cx, _CwPodElement2.default.labelinvalid, props.label && props.invalid), (0, _defineProperty3.default)(_cx, 'CwPodElement-labelblue', props.label && props.labelBlue), _cx)) },
    props.label,
    props.widget
  );
};

CwPodElement.propTypes = {
  labelBlue: _propTypes2.default.bool,
  label: _propTypes2.default.element,
  isRequired: _propTypes2.default.bool,
  invalid: _propTypes2.default.bool,
  widget: _propTypes2.default.element,
  ghostPodElement: _propTypes2.default.bool
};

exports.default = CwPodElement;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpod/CwPodElement.js
// module id = 848
// module chunks = 10